//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Task_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Task-CCP.interface';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { saveAs } from 'file-saver';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Download_Log_CCP } from 'src/app/Constants/Backlog/CCP/Download_Log';


@Component({
    selector: 'app-check-task-assig-ccp',
    templateUrl: './check-task-assig-ccp.component.html',
    styleUrls: ['./check-task-assig-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css', '../../../../../Styles/TasksGlobal.css'],
    standalone: false
})
export class CheckTaskAssigCCPComponent implements OnInit {

  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM REASON REJECT =====================+\\
  public FormReject: FormGroup = new FormGroup({
    ReasonText: new FormControl('', [Validators.required, Validators.minLength(5)])
  })


  //-========================= SECTION VARIABLES =========================-\\

  //+================== VARIABLES FOR TASK ==================+\\
  private ID_Task: number = 0;
  public Task_CCP: Task_CCP = {
    ID: 0,
    ID_WF: 0,
    ID_Involved_User: 0,
    Status: 0,
    Date_Start: null,
    Name: '',
    NameUser: '',
    Route_Destination: '',
    Invoice_4M:''
  };

  //+================== VARIABLES FOR PREVIEW ==================+\\
  public showPreview: boolean = false;
  public previewFileName: string = '';
  public previewFileUrl: string = '';
  public previewFileExtension: string = '';


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  constructor(private router: Router, private activatedRouter: ActivatedRoute, private Service_CCP: LIBRARYCCPService) {
    this.ID_Task = this.activatedRouter.snapshot.params['idT'];
  }

  ngOnInit(): void {

    this.Load_Component_Task();

  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_Task(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResTask: any = await firstValueFrom(this.Service_CCP.GetInfoOfTask(this.ID_Task));

      if (ResTask.success) {
        this.Task_CCP = ResTask.operation;
        Loader.classList.remove('active');

        const DataTask: any = ResTask.operation;

        if (DataTask.Status != 1) {
          Swal.fire({
            title: 'Ya no puedes revisar esta tarea ',
            text: '¡Esta tarea ya se ha revisado anteriormente!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          }).then((result) => {
            this.router.navigate(['Dashboard/CCP/SeeAllTasksLibCCP']);
          })

        }
      }


    } catch (e) {
      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR FORMAT DATE ASSIGNED ==================-\\
  public GetDate_Assigned(Date_Assigned: Date | null): string {
    return moment(Date_Assigned).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================== FUNCTTION FOR SEE FILE CCP IN LIBRARY ==================-\\
  public SeeCCPLibrary(): void {

    let Route: string[] = this.Task_CCP.Route_Destination.split('/') || ['']; Route.pop();

    const RouteSend: string = Route.join('/');

    const RouteEncode: string = encodeURIComponent(RouteSend);

    this.router.navigate([`Dashboard/CCP/FMLibraryCCP/${RouteEncode}`]);
  }

  //-======================== DOWNLOAD FILE CCP ========================-\\
  public async DownloadFile(): Promise<void> {
    const Btn_Download = document.getElementById('Btn-Download') as HTMLDivElement;
    Btn_Download.classList.add('active');

    const Progress_Bar_Task = document.getElementById('Progress-Bar-Task') as HTMLSpanElement;

    try {
      const ResGetURLCCP: any = await firstValueFrom(this.Service_CCP.Get_URL_DownloadCCP({ ID_CCP: this.Task_CCP.ID_WF, Type_D: Download_Log_CCP.D_SPECIFIC_TASK }));

      if (ResGetURLCCP.success) {
        const URL = ResGetURLCCP.operation.URL_CCP;

        this.Service_CCP.DownloadCCP(URL).subscribe((event: any) => {

          const Text_Btn = document.getElementById('Text-Btn') as HTMLElement;
          const Icon_Btn = document.getElementById('Icon-Btn') as HTMLElement;

          if (event.status === 404) {
            Btn_Download.classList.remove('active');
            Progress_Bar_Task.style.width = '0%';
            Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
            Text_Btn.innerHTML = 'Error';

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'error',
              title: '¡Error al descargar la HOE, informa a tu supervisor!'
            })

          }



          if (event['loaded'] && event['total']) {

            let Discharge_Rate: number = Math.round(event['loaded']) / event['total'] * 100;

            Progress_Bar_Task.style.width = Discharge_Rate + '%';

          }
          if (event['body']) {

            Progress_Bar_Task.style.width = '0%';
            Btn_Download.classList.remove('active');


            if (event.status === 200) {

              Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
              Text_Btn.innerHTML = 'Completada';

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'success',
                title: 'HOE descargada!'
              })

              saveAs(event['body'], this.Task_CCP.Name);
            }





          }
        })
      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡ha ocurrido un error, intente recargar la página, si el problema persiste informe supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTION FOR APPROVED CCP ==================-\\
  public ApproveCCP(): void {

    Swal.fire({
      title: '¿Ya ha revisado la HOE?',
      text: "¡Antes de aprobar una tarea tendrá que revisarla!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, aprobar!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        const Loader = document.getElementById('Loader') as HTMLDivElement;
        Loader.classList.add('active');


        try {

          const ResApproved: any = await firstValueFrom(this.Service_CCP.ApproveTask({ ID: this.Task_CCP.ID }));

          if (ResApproved.success) {

            Loader.classList.remove('active');
            Swal.fire({
              icon: 'success',
              title: 'Ha aprobado la tarea',
              timer: 3000,
              confirmButtonColor: this.ColorConfirm
            }).then((result) => {
              this.router.navigate(['Dashboard/CCP/SeeAllTasksLibCCP']);
            })

          }

        } catch (e) {

          Loader.classList.remove('active');
          Swal.fire({
            title: 'Ocurrió un error al aprobar la tarea',
            text: '¡Notifique este error al supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }

      }
    })
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTION FOR REJECT CCP =====================&\\

  //-================== FUNCTION FOR SAVE REASON REJECT ==================-\\
  public SaveReject(): void {
    const IsValidForm = this.ValidationFormReject();

    if (this.FormReject.valid && IsValidForm) {

      const Reason: string = this.FormReject.controls['ReasonText'].value;

      Swal.fire({
        title: '¿Desea enviar la razón de rechazo?',
        text: `¡No podrá revertir cambios!`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, enviar!',
        cancelButtonText: 'No, cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Marque la casilla para confirmar el envió de la razón de rechazo!`,
            input: 'checkbox',
            inputPlaceholder: 'Enviar razón de rechazo',
            confirmButtonText: 'Continuar <i class="fa-solid fa-arrow-right"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then(async (resultRem) => {

            if (resultRem.value===1) {

              try {

                const ResRejectTask: any = await firstValueFrom(this.Service_CCP.RejectedTask({ ID: this.Task_CCP.ID, Reason: Reason }));

                if (ResRejectTask.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'HOE rechazada',
                    confirmButtonColor: this.ColorConfirm,
                  })
                  this.ToggleModalReasonReject(false);
                  this.router.navigate(['Dashboard/CCP/SeeAllTasksLibCCP']);
                }

              } catch (e) {
                Swal.fire({
                  title: 'Ocurrió un error al aprobar la tarea',
                  text: '¡Notifique este error al supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.ToggleModalReasonReject(false);
                this.router.navigate(['Dashboard/CCP/SeeAllTasksLibCCP']);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para enviar la razón de rechazo !',
                confirmButtonColor: this.ColorConfirm
              })
            }
          })
        }
      })
    }
  }

  //-================== FUNCTION FOR VALIDATE FORM ==================-\\
  private ValidationFormReject(): boolean {

    const IdTextAreaRejectCCP = document.getElementById('IdTextAreaRejectCCP') as HTMLTextAreaElement; IdTextAreaRejectCCP.classList.remove('Is-Invalid-Form');

    if (!this.FormReject.controls['ReasonText'].valid) {
      IdTextAreaRejectCCP.classList.add('ng-invalid'); IdTextAreaRejectCCP.classList.add('ng-touched');

      if (this.FormReject.controls['ReasonText'].value == '') {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡Ingresa una razón de rechazo!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      } else {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡La razón de rechazo es muy corta!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      }

    }

    return true;
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL REASON REJECT ==================-\\
  public ToggleModalReasonReject(CloseOrOpen: boolean): void {
    const ModalReject = document.getElementById('ModalReject') as HTMLDivElement;
    CloseOrOpen ? ModalReject.classList.add('active') : ModalReject.classList.remove('active');
  }

  //&===================== END FUNCTION FOR REJECT CCP =====================&\\

  //-======================== PREVIEW FILE CCP ========================-\\
  public async PreviewFile(event?: Event): Promise<void> {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    if (Loader) Loader.classList.add('active');

    try {
      const res: any = await firstValueFrom(
        this.Service_CCP.Get_URL_DownloadCCP({
          ID_CCP: this.Task_CCP.ID_WF,
          Type_D: Download_Log_CCP.D_SPECIFIC_TASK,
          isPreview: true
        })
      );

      if (Loader) Loader.classList.remove('active');

      if (!res.success) {
        throw new Error('No se pudo resolver la URL de la vista previa.');
      }

      this.previewFileUrl = String(res.operation?.URL_CCP || '').trim();
      this.previewFileName = this.Task_CCP.Name;
      this.previewFileExtension = this.Task_CCP.Name.split('.').pop() || '';
      this.showPreview = true;
    } catch (e) {
      if (Loader) Loader.classList.remove('active');
      console.error(e);
      Swal.fire('Error', 'No se pudo cargar la vista previa', 'error');
    }
  }

  public DownloadFromPreview(): void {
    this.DownloadFile();
  }

}

